import React from "react";
import { motion } from "framer-motion";

const Partners = () => {
  // ✅ Logos from public/img
  const partners = Array.from({ length: 10 }, (_, i) => `/img/p${i + 1}.png`);

  return (
    <section className="relative py-5   bg-white text-gray-900 overflow-hidden">
      {/* Subtle gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-blue-50/30 to-transparent pointer-events-none"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Our <span className="text-blue-600">Partners</span>
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
Building strong collaborations with industry-leading organizations.

            </p>
          </motion.div>
        </div>

        {/* Partners Carousel */}
        <div className="relative">
          {/* Left fade */}
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent z-20 pointer-events-none"></div>
          {/* Right fade */}
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-20 pointer-events-none"></div>

          <div className="overflow-hidden w-full">
            <motion.div
              animate={{ x: ["0%", "-50%"] }}
              transition={{
                repeat: Infinity,
                duration: 30,
                ease: "linear",
              }}
              className="flex w-max gap-6 py-12"
            >
              {/* Duplicate logos for seamless loop */}
              {partners.concat(partners).map((src, index) => (
                <motion.div
                  key={index}
                  whileHover={{ scale: 1.08, y: -5 }}
                  className="flex items-center justify-center
                  bg-white
                  border border-gray-200
                  rounded-xl px-12 py-8
                  min-w-[180px] sm:min-w-[220px]
                  transition-all duration-300
                  hover:border-blue-400 hover:shadow-lg"
                >
                  <img
                    src={src}
                    alt={`partner-${index + 1}`}
                    className="h-16 sm:h-20 w-auto object-contain"
                    loading="lazy"
                  />
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>

        {/* Trust badge */}
        {/* <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <p className="text-gray-600 text-sm font-medium">
            Trusted by 50+ Global Organizations
          </p>
        </motion.div> */}
      </div>
    </section>
  );
};

export default Partners;
